import { FlagsComponentRouter } from 'flags'

import OffComponent from './flag.off/index'
import OnComponent from './flag.on/index'

const FlagToggler = FlagsComponentRouter({
  flagSubscriptions: ['feature_learn-18822-HS-user-progress-reporting'],
  OnComponent,
  OffComponent,
})

export default FlagToggler
